import React from 'react';

import { Box, Flex, Heading } from '@chakra-ui/react';
import Link from 'next/link';

import { Loader } from '@components/custom-loader';
import { IconRenderer } from '@components/IconComponent';
import { useGetDomainsQuery } from '@modules/common/api';
import { DOMAIN_QUERY_NAME } from '@modules/find-mentor/components/sections/DomainTabs';

export default function ExploreMentorshipDomains() {
    const { data, isLoading } = useGetDomainsQuery();
    const bgColors = ['#FAF5FF', '#F7FAFC', '#FFFAF0', '#FDF2F8', '#EDFAFA', '#F0FFF4', '#E6FFFA'];

    return (
        <Box py="100px">
            <Heading
                color="titleText"
                fontWeight="medium"
                textAlign="center"
                px={{ base: '10px', md: 0 }}
            >
                Explore Mentorship Domains
            </Heading>
            {isLoading ? (
                <Box height="20vh">
                    <Loader position="absolute" height="20vh" width="100%" size="lg" />
                </Box>
            ) : (
                <Flex
                    justify="center"
                    flexWrap="wrap"
                    gap={{ base: '12px', md: '16px' }}
                    width={{ base: '100%', lg: '90%', xl: '80%' }}
                    mx="auto"
                    py={5}
                    mt={2}
                >
                    {data?.domain.map((domain, index) => (
                        <Link
                            key={domain.id}
                            href={`/find-mentor?${DOMAIN_QUERY_NAME}=${domain.id}`}
                            passHref
                        >
                            <Heading
                                cursor="pointer"
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                gap="12px"
                                p={6}
                                borderRadius="8px"
                                bg={bgColors[index % bgColors.length]}
                                color="titleText"
                                fontWeight="medium"
                                fontSize="18px"
                                width="fit-content"
                                whiteSpace="nowrap"
                                border="1px"
                                borderColor="border"
                                lineHeight={1.3}
                                flexBasis={{ base: '100%', sm: '48%', md: '30%', lg: '10%' }}
                                transition="all 0.3s ease"
                                _hover={{
                                    transform: 'scale(1.05)',
                                    boxShadow: '0 0 5px rgba(0, 0, 0, 0.1)',
                                }}
                            >
                                <Box
                                    as="span"
                                    display="flex"
                                    alignItems="center"
                                    color="mainText"
                                    fontSize="30px"
                                >
                                    <IconRenderer
                                        iconName={domain.icon}
                                        iconPack={domain.iconPack}
                                    />
                                </Box>
                                {domain.name}
                            </Heading>
                        </Link>
                    ))}
                </Flex>
            )}
        </Box>
    );
}
